import { Component, ViewChild } from '@angular/core';
import { count, filter, map } from 'rxjs/operators';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { NotifierService } from '../../services/notifier/notifier.service';
import { Subject } from 'rxjs';

import { takeUntil } from 'rxjs/operators';

import { OnDestroy } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { Howl } from 'howler';

import { MatSort } from '@angular/material/sort';
import { ThingsModel } from 'src/app/models/ThingsModel';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';

import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AddUsersDialogComponent } from 'src/app/dialogs/add-users-dialog/add-users-dialog.component';
import { AddThingsDialogComponent } from 'src/app/dialogs/add-things-dialog/add-things-dialog.component';
import { HeliumService } from 'src/app/services/helium/helium.service';
import { ConfirmDeleteDialogComponent } from 'src/app/dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Event as NavigationEvent } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RebootDialogComponent } from 'src/app/dialogs/reboot-dialog/reboot-dialog.component';
//Setup jQuery
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-devicelist',
  templateUrl: './devicelist.component.html',
  styleUrls: ['./devicelist.component.scss'],
})
export class DevicelistComponent implements OnDestroy {
  /** Based on the screen size, switch from standard to one column per row */
  private refreshTimer: any = undefined;
  private activitySpinner: boolean = false;

  //Locals : General
  private alarmSound: any = new Howl({
    src: ['assets/sound/woop_woop.mp3'],
  });
  public showTodo: boolean = true;
  public fwVersion: number = 0;
  //Grid list behaviour
  public isHandSet: boolean = false;
  private destroyed = new Subject<void>();
  private currentScreenSize: string;
  private breakpoints: number = 6;
  public columns: number = 6;
  private gridByBreakpoint = {
    XLarge: 8,
    Large: 6,
    Medium: 4,
    Small: 2,
    XSmall: 1,
  };
  private displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

  public additionalDetailsSelection = 'hotspot';
  public blockchainActivitySelection = 'activity';

  //Things Table
  @ViewChild(MatTable) thingsTable: MatTable<ThingsModel>;
  @ViewChild('matPagProtons') thingsPaginator: MatPaginator;
  @ViewChild(MatSort) thingsSort: MatSort;
  public protonDispCols: string[] = [
    'id',
    'name',
    'address',
    'owner',
    'earnings',
    'minerVersion',
    'fwVersion',
    'status',
    'star',
  ];
  public protonsDataSource: MatTableDataSource<any> =
    new MatTableDataSource<any>();

  public selectedDevice: any = {
    name: '',
  };

  public deviceListPaginotorTracker: any = {
    index: 0,
    size: 10,
  };

  public tableInfo = [];

  public selectedDeviceRaw: any = [];
  public selectedPage = 0;

  constructor(
    private _snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver,
    private notifier: NotifierService,
    public globals: GlobalsService,
    private api: ApiService,
    private router: Router,
    public dialog: MatDialog,
    public heliumService: HeliumService
  ) {
    //Determine screen size and handle breakpoints
    breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            //Screen size
            this.currentScreenSize = this.displayNameMap.get(query);

            //Set breakpoints
            this.breakpoints = this.gridByBreakpoint[this.currentScreenSize];
            this.isHandSet = this.breakpoints < 3 ? true : false;
            this.columns = this.isHandSet ? 2 : 6;
          }
        }
      });
  }

  //#region : Angular callbacks
  async ngOnInit() {
    // window.addEventListener("keyup", this.disableF5);
    // window.addEventListener("keydown", this.disableF5);
    localStorage.setItem('lastpage', 'devicelist');

    if (this.globals.directRouting) {
      this.getData();
    }

    //Init user table
    this.initThingsTable();
  }

  disableF5(e) {
    if ((e.which || e.keyCode) == 116) {
      e.preventDefault();
    }
  }

  ngAfterViewInit() {
    this.initTableAddons();

    //Timer for table refresh
    this.refreshTimer = setInterval(() => {
      this.refreshPage(false);
    }, 60000);
  }

  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    clearTimeout(this.refreshTimer);
  }

  //#endregion

  //#region : Dashboard grid initialisation

  initTableAddons() {
    //Things table addons
    this.protonsDataSource.paginator = this.thingsPaginator;
    this.protonsDataSource.sort = this.thingsSort;
  }
  //#endregion

  //#region : Helpers
  showNotification() {
    this.notifier.showNotification('Hello World', 'OK');
  }

  //#endregion

  //#region : Things table
  initThingsTable() {
    //Clear tableInfo
    this.tableInfo = [];

    if (this.globals.fullDeviceList.length == 0) {
      //get devices
      //Display "no data" in table
    }

    //Unpack this.globals.fullDeviceList to tableInfo

    for (let i = 0; i < this.globals.fullDeviceList.length; i++) {
      let d = this.globals.fullDeviceList[i];

      let device = {
        name: d.name,
        address: '',
        owner: '',
        snr: d.snr,
        fw: undefined,
        miner: undefined,

        cpuId: '',
        ethMac: '',
        wifiMac: '',
        batchNr: '',

        prod_time: '',
        collectTime: '',
        addedTime: '',
        uptime: '',

        lanIp: '0.0.0.0',
        wifiIp: '0.0.0.0',
        public_ip: '0.0.0.0',
        wifiSSID: 'N/A',

        p2pdata: undefined,
        earnings: {
          day: 0,
          week: 0,
          month: 0,
          total: 0,
          scale: 0,
        },
        status: {
          online: false,
          synced: false,
          syncedPercentage: 0,
          relayed: false,
          minerHeight: 0,
          heliumHeight: 0,
        },
        position: {
          lat: 0,
          lng: 0,
          geocode: {
            long_country: '',
            long_state: '',
            long_city: '',
            long_street: '',
          },
        },
        antenna: {
          gain: 0,
          elevation: 0,
        },
        cpu: {
          temp: 0,
          usage: 0,
        },
        memory: {
          total: 0,
          free: 0,
          used: 0,
          available: 0,
          tooltip: '0 MB',
        },
        storage: {
          size: 0,
          used: 0,
          available: 0,
          tooltip: '0 GB',
        },
        online: '',
        hasWarning: false,
        warningList: [],
        warningMessage: '',
        peers: [],
      };

      //Get cpuid key
      let cpuIdInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'cpu_id'
      );
      device.cpuId = cpuIdInd != -1 ? d.attributes[cpuIdInd].value : 'N/A';

      //Get ethMac key
      let ethMacInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'eth_mac'
      );
      device.ethMac = ethMacInd != -1 ? d.attributes[ethMacInd].value : 'N/A';

      //Get ethMac key
      let wifiMacInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'wifi_mac'
      );
      device.wifiMac =
        wifiMacInd != -1 ? d.attributes[wifiMacInd].value : 'N/A';

      //Get ethMac key
      let batchInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'batch_nr'
      );
      device.batchNr = batchInd != -1 ? d.attributes[batchInd].value : 'N/A';

      //Get public key
      let pubKeyInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'public_key'
      );
      device.address = pubKeyInd != -1 ? d.attributes[pubKeyInd].value : 'N/A';

      //Get owner
      let ownerInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'owner'
      );
      device.owner = ownerInd != -1 ? d.attributes[ownerInd].value : 'N/A';

      //Helium FW version
      let fwInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'helium_fw_version'
      );
      device.fw = fwInd != -1 ? d.attributes[fwInd].value : 'N/A';
      if (typeof device.fw == 'object') {
        device.fw = device.fw.version ? device.fw.version : 'N/A';
      }

      let minerInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'proton_fw_version'
      );
      device.miner = fwInd != -1 ? d.attributes[minerInd].value : 'N/A';
      if (typeof device.miner == 'object') {
        device.miner = device.miner.version ? device.miner.version : 'N/A';
      }

      //Position
      let posInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'position'
      );
      device.position =
        posInd != -1
          ? d.attributes[posInd].value
          : {
              lat: 0,
              lng: 0,
              geocode: {
                long_country: '',
                long_state: '',
                long_city: '',
                long_street: '',
              },
            };

      //Antenna
      let antInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'antenna'
      );
      device.antenna =
        antInd != -1
          ? d.attributes[antInd].value
          : {
              gain: 0,
              elevation: 0,
            };

      //Helium Status
      let hsInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'helium_status'
      );
      device.addedTime =
        hsInd != -1 ? d.attributes[hsInd].value.date_added : 'N/A';

      //Production Time
      let ptInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'production_time'
      );
      device.prod_time = ptInd != -1 ? d.attributes[ptInd].value : 'N/A';

      //Earnings
      let rewInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'rewards'
      );
      device.earnings =
        rewInd != -1
          ? {
              day: d.attributes[rewInd].value.day
                ? d.attributes[rewInd].value.day
                : 0,
              week: d.attributes[rewInd].value.week
                ? d.attributes[rewInd].value.week
                : 0,
              month: d.attributes[rewInd].value.month
                ? d.attributes[rewInd].value.month
                : 0,
              total: d.attributes[rewInd].value.total
                ? d.attributes[rewInd].value.total
                : 0,
              scale: d.attributes[rewInd].value.scale
                ? d.attributes[rewInd].value.scale
                : 0,
            }
          : {
              day: 0,
              week: 0,
              month: 0,
              total: 0,
              scale: 0,
            };

      //Online
      // let onlineInd = this.globals.arrayFindWithAttr(d.attributes, "name", "online");
      // device.status.online = onlineInd != -1 ? d.attributes[onlineInd].value : false;

      //Determine online status from lastcomms
      let lc = new Date(d.lastcomms);
      let curr = new Date();

      let diff = curr.getTime() - lc.getTime();

      //also created != lastcomms
      let cr = new Date(d.created);
      let flag = lc.getTime() - cr.getTime() > 10000; //Make sure lastcomms is bigger than created

      //If device has no comms in 10mins then it is offline
      device.status.online = diff < 60 * 60000 && flag ? true : false;

      //Set online value just for search
      device.online = diff < 60 * 60000 && flag ? 'online' : 'offline';
      //Synced
      let syncedInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'synced'
      );
      device.status.synced =
        syncedInd != -1 ? d.attributes[syncedInd].value : false;

      //Relayed
      let relayedInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'relayed'
      );
      device.status.relayed =
        relayedInd != -1 ? d.attributes[relayedInd].value : false;

      //Uptime : sec to days min hours
      let uptimeInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'uptime'
      );
      device.uptime =
        uptimeInd != -1
          ? this.globals.secondsToDhms(d.attributes[uptimeInd].value)
          : '';

      //Public IP
      let pubIPInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'public_ip'
      );
      device.public_ip =
        pubIPInd != -1 ? d.attributes[pubIPInd].value : '0.0.0.0';

      //Cpu temp
      let cpuTempInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'cpu_temperature'
      );
      device.cpu.temp = cpuTempInd != -1 ? d.attributes[cpuTempInd].value : 0;

      //Cpu Usage
      let cpuUseInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'cpu_usage'
      );
      device.cpu.usage = cpuUseInd != -1 ? d.attributes[cpuUseInd].value : 0;

      //Peers
      let peersInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'peers'
      );
      device.peers = peersInd != -1 ? d.attributes[peersInd].value : [];

      // Mem usage
      let memUseInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'memory_usage'
      );
      device.memory =
        memUseInd != -1
          ? d.attributes[memUseInd].value
          : {
              total: 0,
              free: 0,
              used: 0,
              available: 0,
              tooltip: '0 MB',
            };

      //Calc tooltip
      device.memory.tooltip =
        memUseInd != -1
          ? `${(
              (d.attributes[memUseInd].value.total -
                d.attributes[memUseInd].value.available) /
              (1024 * 1024)
            ).toFixed(0)} / ${(
              d.attributes[memUseInd].value.total /
              (1024 * 1024)
            ).toFixed(0)} MB`
          : '0 MB';

      //sd usage
      let storageInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'storage_usage'
      );
      device.storage =
        storageInd != -1
          ? d.attributes[storageInd].value
          : {
              size: 0,
              used: 0,
              available: 0,
              tooltip: '0 GB',
            };

      // WifiSSID
      let wifiSSIDInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'wifi_ssid'
      );
      device.wifiSSID =
        wifiSSIDInd != -1 && d.attributes[wifiSSIDInd].value != -1
          ? d.attributes[wifiSSIDInd].value
          : 'N/A';

      //WifiIp
      let wifiIpInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'wifi_ip'
      );
      device.wifiIp =
        wifiIpInd != -1 ? d.attributes[wifiIpInd].value : '0.0.0.0';

      //LanIp
      let lanIpInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'lan_ip'
      );
      device.lanIp = lanIpInd != -1 ? d.attributes[lanIpInd].value : '0.0.0.0';

      //Calc tooltip
      device.storage.tooltip =
        storageInd != -1
          ? `${(
              d.attributes[storageInd].value.used /
              (1024 * 1024 * 1024)
            ).toFixed(2)} / ${(
              d.attributes[storageInd].value.size /
              (1024 * 1024 * 1024)
            ).toFixed(2)} GB`
          : '0 GB';

      //p2pStatus
      let p2pInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'p2p_status'
      );
      device.p2pdata =
        p2pInd != -1
          ? d.attributes[p2pInd].value != -1
            ? d.attributes[p2pInd].value
            : undefined
          : undefined;

      //synced percentage
      let hbHeightInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'helium_block_height'
      );
      let heliumBlockHeight =
        hbHeightInd != -1
          ? d.attributes[hbHeightInd].value != -1
            ? d.attributes[hbHeightInd].value
            : undefined
          : undefined;

      let mbHeightInd = this.globals.arrayFindWithAttr(
        d.attributes,
        'name',
        'miner_block_height'
      );
      let minerBlockHeight =
        mbHeightInd != -1
          ? d.attributes[mbHeightInd].value != -1
            ? d.attributes[mbHeightInd].value
            : undefined
          : undefined;

      if (heliumBlockHeight && minerBlockHeight) {
        device.status.heliumHeight = heliumBlockHeight;
        device.status.minerHeight = minerBlockHeight;

        device.status.syncedPercentage =
          (minerBlockHeight / heliumBlockHeight) * 100 > 100
            ? 100
            : (minerBlockHeight / heliumBlockHeight) * 100;
      }

      //Handle issues

      //cpu temp
      if (device.cpu?.temp > 70) {
        device.hasWarning = true;
        device.warningList.push('CPU Temp high: ' + device.cpu?.temp + '&deg;');
      }
      //cpu usage
      if (device.cpu?.usage > 80) {
        device.hasWarning = true;
        device.warningList.push(
          'High CPU Usage: ' + device.cpu?.usage.toFixed(2) + '%'
        );
      }
      //mem usage
      if (
        (100 * (device.memory.total - device.memory.available)) /
          device.memory.total >
        80
      ) {
        let mem =
          (100 * (device.memory.total - device.memory.available)) /
          device.memory.total;
        device.hasWarning = true;
        device.warningList.push('High Memory Usage: ' + mem.toFixed(2) + '%');
      }
      //Storage usage
      if ((device.storage.used / device.storage.size) * 100 > 85) {
        let storage = (device.storage.used / device.storage.size) * 100;
        device.hasWarning = true;
        device.warningList.push(
          'High Storage Usage: ' + storage.toFixed(2) + '%'
        );
      }

      //Offline
      if (device.online == 'offline') {
        device.hasWarning = true;
        device.warningList.push('Device Offline');
      }

      for (let i = 0; i < device.warningList.length; i++) {
        //NOTE: Keep newline (enter) in the below) statement
        device.warningMessage =
          i == 0
            ? device.warningMessage.concat(device.warningList[i])
            : device.warningMessage.concat(`
        ${device.warningList[i]}`);
      }

      //Collection time : TODO: update in
      device.collectTime = d.lastcomms;

      this.tableInfo.push(device);
    }

    // this.protonsDataSource.data = this.globals.fullDeviceList
    this.protonsDataSource.data = this.tableInfo;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    //Show noti

    this._snackBar.open('Copied to Clipboard', '', {
      duration: 1000,
      // panelClass: 'green-snackbar',
      horizontalPosition: 'end',
    });
  }

  applyThingsFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.protonsDataSource.filter = filterValue.trim().toLowerCase();

    if (this.protonsDataSource.paginator) {
      this.protonsDataSource.paginator.firstPage();
    }
  }
  //TODO
  onThingsmenuEdit(thingId: number) {
    // console.log(thingId);
  }

  //TODO
  onThingsmenuDelete(thingId: number) {
    // console.log(thingId);
  }

  //TODO
  onThingsmenuMore(thingId: number) {
    // console.log(thingId);
  }

  onThingsmenuInfo(thingId: number) {
    // console.log(thingId);
  }

  addThing() {
    const dialogRef = this.dialog.open(AddThingsDialogComponent, {
      width: '640px',
      disableClose: true,
      backdropClass: 'bdrop',
    });
  }
  //#endregion

  //#region : Dialogs
  openAddUserDialog(): void {
    const dialogRef = this.dialog.open(AddUsersDialogComponent, {
      width: '640px',
      disableClose: true,
      backdropClass: 'bdrop',
    });
  }

  openAddDeviceDialog(): void {
    const dialogRef = this.dialog.open(AddThingsDialogComponent, {
      width: '640px',
      disableClose: true,
      backdropClass: 'bdrop',
    });
  }

  clickAddress(address: string) {
    let url = `https://explorer.helium.com/hotspots/${address}`;

    window.open(url, '_blank');
  }

  clickValidatorAddress(address: string) {
    let url = `https://explorer.helium.com/validators/${address}`;

    window.open(url, '_blank');
  }

  clickOwner(owner: string) {
    let url = `https://explorer.helium.com/accounts/${owner}`;
    window.open(url, '_blank');
  }

  onProtonPageChange(event: any) {
    let currPage = event.pageIndex;
    let pageSize = event.pageSize;
    this.selectedPage = currPage;

    this.deviceListPaginotorTracker.index = currPage;
    this.deviceListPaginotorTracker.size = pageSize;
    // console.log(event);
  }

  selectDevice(ind, row) {
    let index =
      this.deviceListPaginotorTracker.index *
        this.deviceListPaginotorTracker.size +
      ind;
    let add = row.address;

    //Get selected devcie by address
    let indx = this.globals.arrayFindWithAttr(this.tableInfo, 'address', add);

    this.selectedDevice = this.tableInfo[indx];

    // Get fireware version : Determine if the reboot button should be displayed
    let firmwareVersion = this.selectedDevice.miner;
    firmwareVersion = parseFloat(firmwareVersion.substr(1, 5));
    this.fwVersion = firmwareVersion;

    this.selectedDevice.collectTime1 = this.globals.getLocalDateString(
      new Date(this.selectedDevice.collectTime)
    );
    this.selectedDevice.addedTime = this.globals.getLocalDateString(
      new Date(this.selectedDevice.addedTime)
    );
    this.selectedDevice.prod_time = this.globals.getLocalDateString(
      new Date(this.selectedDevice.prod_time)
    );

    //Format Times
    if (!this.selectedDevice.position.lat) this.selectedDevice.position.lat = 0;
    if (!this.selectedDevice.position.lng) this.selectedDevice.position.lng = 0;

    //Get raw data
    this.selectedDeviceRaw = [];
    this.api.rawListCount(`PRO_${this.selectedDevice.snr}`, 11, (data: any) => {
      //Unpack raw data
      for (let raw of data) {
        let state = raw.state && raw.state.status ? raw.state.status : [];

        let entry = {
          date: this.globals.getLocalDateString(new Date(raw.created)),
          miner: 0,
          helium: 0,
          percentage: 0,
        };

        //Format date

        //synced percentage
        let hbHeightInd = this.globals.arrayFindWithAttr(
          state,
          'check',
          'helium_block_height'
        );
        let heliumBlockHeight =
          hbHeightInd != -1
            ? state[hbHeightInd].result != -1
              ? state[hbHeightInd].result
              : undefined
            : undefined;

        let mbHeightInd = this.globals.arrayFindWithAttr(
          state,
          'check',
          'device_block_height'
        );
        let minerBlockHeight =
          mbHeightInd != -1
            ? state[mbHeightInd].result != -1
              ? state[mbHeightInd].result
              : undefined
            : undefined;

        if (heliumBlockHeight && minerBlockHeight) {
          entry.helium = heliumBlockHeight;
          entry.miner = parseInt(minerBlockHeight);

          let perc =
            (minerBlockHeight / heliumBlockHeight) * 100 > 100
              ? 100
              : (minerBlockHeight / heliumBlockHeight) * 100;
          entry.percentage = Math.floor(perc * 1000) / 1000;

          this.selectedDeviceRaw.push(entry);
        }
      }

      //loop through rawand get diff
      for (let i = 0; i < this.selectedDeviceRaw.length; i++) {
        if (this.selectedDeviceRaw[i + 1]) {
          this.selectedDeviceRaw[i].diff =
            this.selectedDeviceRaw[i].miner -
            this.selectedDeviceRaw[i + 1].miner;
        }
      }
    });

    this.selectedDevice.validator = {
      status: null,
      name: null,
      ip: null,
      lastHeartbeat: null,
      version: null,
      listenIP: null,
      address: null,
    };
    // console.log(this.selectedDevice.peers)
    //Get validator info
    this.api.getHotspotValidator(this.selectedDevice.peers, (validator) => {
      // validator.status = false
      this.selectedDevice.validator = validator;
    });

    //Get Activity Info
    this.selectedDevice.activities = [];
    this.activitySpinner = true;
    this.api.getHotspotActivity(add, (activity) => {
      this.selectedDevice.activities = activity;
      this.activitySpinner = false;
    });
  }

  decommission(element: any) {
    //Decommission
    let me = this;
    let snr: string = element.snr;

    //Ask first
    let dialogRef = me.dialog.open(ConfirmDeleteDialogComponent, {
      // width: '640px',
      disableClose: true,
      backdropClass: 'bdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.event == 'Add') {
      } else if (result.event == 'Update') {
      } else if (result.event == 'Delete') {
        me.api.decommissionDevice(
          snr,
          'proton',
          (data) => {
            //Redraw data
            let devs = me.globals.fullDeviceList;

            //Find by attr
            let ind = me.globals.arrayFindWithAttr(devs, 'snr', data.serial);

            if (ind != -1) {
              //Pop from array
              me.globals.fullDeviceList.splice(ind, 1);
              me.tableInfo = [];
              me.initThingsTable();
              // me.protonsDataSource.data = me.globals.fullDeviceList;
            }
          },
          () => {}
        );
      }
    });
  }
  //#endregion

  async getData() {
    //repopulate Devices
    this.api.deviceList(
      (devices: any) => {
        this.globals.devicesLoading = false;
        //Update devicelist
        this.globals.fullDeviceList = devices;

        //Get device stats
        this.initThingsTable();
      },
      () => {
        this.globals.devicesLoading = false;
      }
    );
  }
  //#region : Reboot proton miner
  reboot() {
    //Ask first
    const dialogRef = this.dialog.open(RebootDialogComponent, {
      // width: '640px',
      disableClose: true,
      backdropClass: 'bdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.event == 'Reboot') {
        this.api.minerReboot(
          this.selectedDevice.snr,
          (res: any) => {
            this.globals.devicesLoading = false;
            if (res) {
              this._snackBar.open('Successful', '', {
                duration: 3000,
                panelClass: ['green-snackbar'],
              });
            } else {
              this._snackBar.open('Failed', '', {
                duration: 3000,
                panelClass: ['red-snackbar'],
              });
            }
          },
          () => {
            this.globals.devicesLoading = false;
            this._snackBar.open('Failed', '', {
              duration: 3000,
              panelClass: ['red-snackbar'],
            });
          }
        );
      }
    });
  }
  //#endregion

  refreshPage(showSnackbar: boolean = true) {
    this.ngOnInit();

    if (showSnackbar) {
      this._snackBar.open('Refreshed', '', {
        duration: 1000,
        panelClass: 'green-snackbar',
        horizontalPosition: 'end',
      });
    }
  }

  truncate(fullStr: any, strLen: any, separator: any) {
    if (fullStr.length <= strLen) return fullStr;

    separator = separator || '...';

    var sepLen = separator.length,
      charsToShow = strLen - sepLen,
      frontChars = Math.ceil(charsToShow / 2),
      backChars = Math.floor(charsToShow / 2);

    return (
      fullStr.substr(0, frontChars) +
      separator +
      fullStr.substr(fullStr.length - backChars)
    );
  }

  onAdditionalDetailsSelection(selectVal: string) {
    console.log(selectVal);
    this.additionalDetailsSelection = selectVal;
  }

  onBlockChainActivitySelector(selectVal: string) {
    this.blockchainActivitySelection = selectVal;
  }
}
